import { Api } from '@/services/Api.js'

const lib = {}

lib.getConfiguration = (plantId) => {
  return Api().get(`/api/v1.0/configurable-components/config/${plantId}`)
}

lib.getDeviceList = (plantId) => {
  return Api().get(`/api/v1.0/configurable-components/other-sensor/device-list/${plantId}`)
}

lib.setDeviceList = (param) => {
  return Api().post(`/api/v1.0/configurable-components/other-sensor/device-list`, param)
}

export default lib
